export enum storageKeys {
    favoriteItems = 'favoriteItems',
    purchaseItems = 'purchaseItems',
}
